import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AclPermissionDetail } from '@y42/acl/models';
import { createAclPermissionDetail } from '@y42/acl/util/create-acl-permission-detail';
import { connectState, InputObservable, trackByValue } from '@y42/angular/util';
import { Observable } from 'rxjs';
import { ToolbarEmoji } from '../../canvas-main-toolbar.model';
import { toolbarBackdropClass } from '../../constants';

@UntilDestroy()
@Component({
  selector: 'y42-insert-emoji-button',
  templateUrl: './insert-emoji-button.component.html',
  styleUrls: ['./insert-emoji-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsertEmojiButtonComponent {
  @Input() active = false;

  @Input()
  @InputObservable()
  isCanvasEditable = createAclPermissionDetail({ allowed: false });
  private readonly isCanvasEditable$!: Observable<AclPermissionDetail>;

  @Output() readonly selectTool = new EventEmitter<ToolbarEmoji>();

  readonly state = connectState(this, {
    isCanvasEditable: this.isCanvasEditable$,
  });

  protected readonly trackByValue = trackByValue;

  protected readonly toolbarBackdropClass = toolbarBackdropClass;
  protected readonly emojis = toolbarEmojis;
}

const toolbarEmojis: ToolbarEmoji[] = [
  {
    name: 'Thumbs Up',
    code: '1F44D',
    emoji: '👍',
  },
  {
    name: 'Thumbs Down',
    code: '1F44E',
    emoji: '👎',
  },
  {
    name: 'Purple Heart',
    code: '1F49C',
    emoji: '💜',
  },
  {
    name: 'Fire',
    code: '1F525',
    emoji: '🔥',
  },
  {
    name: 'Waving Hand',
    code: '1F44B',
    emoji: '👋',
  },
  {
    name: 'Star-Struck',
    code: '1F929',
    emoji: '🤩',
  },
  {
    name: 'Open Mouth',
    code: '1F62E',
    emoji: '😮',
  },
];
